import { useCallback, useEffect, useState } from "react"
import moment from "moment"

import { Model } from "../../../../models/model"
import { Summary } from "./Summary"
import NumberFormat from "react-number-format"
import { Link } from "react-router-dom"
import { toast } from "react-toastify"

export const FlowSection = ({ form, setForm, handleGetInfoItem, tasksList = null, currentTasks = null, handleOpenNewInvoice }) => {
    // console.log({ form })

    const {
        id_ppto,
        id_cliente,
        separacion_miles,
        separacion_decimales,
        simbolo,
        id_moneda,
        valor_tipo_cambio
    } = form

    const [flowsList, setFlowsList] = useState([])
    const [initialFlowsList, setInitialFlowsList] = useState([])
    const [hitosList, setHitosList] = useState(tasksList || [])
    const [invoicesList, setInvoicesList] = useState([])
    const [buysList, setBuysList] = useState([])
    // const [pptoId, setPPtoId] = useState(id_ppto || form?.id_presupuesto)
    const pptoId = id_ppto || form?.id_presupuesto

    const iniCargarInvoices = useCallback(async () => {

        const params = {
            url: `invoices/by-pptos/all/${pptoId}`,
        }

        const dataList = await Model.getAll(params)
        const dataListNoFlow = dataList?.filter(f => ((f.flow_id === null || f.flow_id === '') && f.estado !== 'anulada'))
        setInvoicesList(dataListNoFlow)

    }, [pptoId])

    const initLoadBuys = useCallback(async () => {

        const filters_ = (new URLSearchParams({ ppto_id: pptoId, origen: 'ventas' })).toString()
        const params = {
            url: `compras/by-pptos/all/?${filters_}`,
        }

        const dataList = await Model.getAll(params)
        const dataListNoFlow = dataList?.compras?.filter(b => ((b.flow_id === null || b.flow_id === '') && b.estado !== 'anulada'))
        setBuysList(dataListNoFlow)

    }, [pptoId])

    const handleGetFlows = useCallback(async () => {

        const filters = {
            id_ppto: pptoId,
            id_item: form.id
        }

        const params = (new URLSearchParams(filters)).toString()
        const resultsFlows = await Model.getAll({
            url: `reports/projections/items/?${params}`,
        })

        // console.log('--flows--', { resultsFlows })
        setFlowsList(resultsFlows)
        setInitialFlowsList(resultsFlows)

    }, [form.id, pptoId])

    const handleGetHitosTasks = useCallback(async () => {

        const resultsHitos = await Model.getAll({
            url: `tasks/hitos/byppto/${pptoId}`,
        })

        setHitosList(resultsHitos)

    }, [pptoId])

    const handleAdd = async (flowType) => {
        const newId = flowsList?.length + 1

        if (!form.id) {
            toast.warning('Falta seleccionar ítem del presupuesto')
            return false

        }

        const newFlow = {
            id: newId,
            porcentaje_flow: 0,
            monto_neto: 0,
            fecha_proyeccion: currentTasks?.fecha_fin ? moment(currentTasks?.fecha_fin).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
            id_tarea: currentTasks ? currentTasks?.id : null,
            tipo_flujo: flowType,
            saved: false
        }

        const resultSaveId = await Model.save({
            url: 'reports/projections/items/new/flow',
            dataForm: {
                id_item: form.id,
                id_ppto: pptoId,
                id_contacto: id_cliente,
                flows: [newFlow]
            }
        })

        const newFlowSaved = {
            ...newFlow,
            id: resultSaveId,
            saved: true
        }

        setFlowsList([...flowsList, newFlowSaved])
    }

    const handleChangeNumber = async (values, id) => {
        if (!values.sourceInfo.event) return false

        const totalItem = parseFloat(form.precio_subtotal)
        const newListUpdate = flowsList.map(flo => {
            if (flo.id === id) {
                return {
                    ...flo,
                    monto_neto: values.floatValue,
                    porcentaje_flow: (values.floatValue / totalItem) * 100
                }
            }

            return flo
        })

        setFlowsList(newListUpdate)
        await calBalances(newListUpdate)

    }

    const handleChangeNumberPercent = async (values, id) => {
        if (!values.sourceInfo.event) return false

        const totalItem = parseFloat(form.precio_subtotal)
        const newListUpdate = flowsList.map(flo => {
            if (flo.id === id) {
                return {
                    ...flo,
                    porcentaje_flow: values.floatValue,
                    monto_neto: (values.floatValue / 100) * totalItem
                }
            }

            return flo
        })

        setFlowsList(newListUpdate)
        await calBalances(newListUpdate)

    }

    const handleChangeHito = async ({ target }, id) => {
        const hitoId = target.value
        const infoHito = hitosList.find(hi => hi.id === hitoId)

        const newListUpdate = flowsList.map(flo => {
            const fecha = infoHito ? moment(infoHito.fecha_fin).format('YYYY-MM-DD') : flo.fecha_proyeccion

            if (flo.id === id) {
                return {
                    ...flo,
                    [target.name]: hitoId,
                    fecha_proyeccion: fecha
                }
            }

            return flo
        })

        setFlowsList(newListUpdate)

    }

    const calBalances = async (flowsUpdate, returnValue = false) => {
        let sumTotalIngresos = 0
        let sumTotalEgresos = 0

        let sumFacturado = 0
        let sumCobrado = 0
        let sumPorCobrar = 0

        let sumGastado = 0
        let sumPagado = 0
        let sumPorPagar = 0

        for (let x = 0; x < flowsUpdate.length; x++) {
            if (flowsUpdate[x].tipo_flujo === 'ingreso') {
                sumTotalIngresos = sumTotalIngresos + parseFloat(flowsUpdate[x].monto_neto)

                if (flowsUpdate[x].info_invoice?.id) {
                    sumFacturado = sumFacturado + parseFloat(flowsUpdate[x].info_invoice?.monto_base)
                    sumCobrado = sumCobrado + parseFloat(flowsUpdate[x].info_invoice?.total_cobrado)
                    sumPorCobrar = sumPorCobrar + parseFloat(flowsUpdate[x].info_invoice?.total_por_cobrar)
                }

            } else {

                if (parseInt(id_moneda) === 4 && parseInt(flowsUpdate[x].id_moneda) !== 4) {
                    // si proyecto es en usd y gasto en moneda local (soles)
                    sumTotalEgresos = sumTotalEgresos + parseFloat(flowsUpdate[x].monto_neto / valor_tipo_cambio)
                } else {
                    sumTotalEgresos = sumTotalEgresos + parseFloat(flowsUpdate[x].monto_neto)
                }

                if (flowsUpdate[x].info_invoice?.id) {

                    if (parseInt(id_moneda) === 4 && parseInt(flowsUpdate[x].id_moneda) !== 4) {
                        // si proyecto es en usd y gasto en moneda local (soles)

                        sumGastado = sumGastado + parseFloat(flowsUpdate[x].info_invoice?.monto_base / valor_tipo_cambio)
                        sumPagado = sumPagado + parseFloat(flowsUpdate[x].info_invoice?.total_pagado / valor_tipo_cambio)
                        sumPorPagar = sumPorPagar + parseFloat(flowsUpdate[x].info_invoice?.total_por_pagar / valor_tipo_cambio)

                    } else {

                        sumGastado = sumGastado + parseFloat(flowsUpdate[x].info_invoice?.monto_base)
                        sumPagado = sumPagado + parseFloat(flowsUpdate[x].info_invoice?.total_pagado)
                        sumPorPagar = sumPorPagar + parseFloat(flowsUpdate[x].info_invoice?.total_por_pagar)

                    }

                }
            }
        }

        const saldoPorProyectar = parseFloat(form.precio_subtotal) - parseFloat(sumTotalIngresos || 0)
        const saldoPorProyectarEgresos = parseFloat(form.costo_subtotal) - parseFloat(sumTotalEgresos || 0)

        const newValues = {
            total_proyectado: sumTotalIngresos,
            saldo_por_proyectar: saldoPorProyectar > 0 ? saldoPorProyectar : 0,
            total_proyectado_egresos: sumTotalEgresos,
            saldo_por_proyectar_egresos: saldoPorProyectarEgresos > 0 ? saldoPorProyectarEgresos : 0,

            total_facturado: sumFacturado,
            total_por_facturar: sumTotalIngresos - sumFacturado,
            total_cobrado: sumCobrado,
            total_por_cobrar: sumPorCobrar,

            total_gastado: sumGastado,
            total_por_gastar: sumTotalEgresos - sumGastado,
            total_pagado: sumPagado,
            total_por_pagar: sumPorPagar
        }

        setForm({
            ...form,
            ...newValues
        })

        if (returnValue) {
            return newValues
        }

    }

    const handleRemove = async (id) => {
        const newListUpdate = flowsList.filter(flo => flo.id !== id)
        setFlowsList(newListUpdate)

        const returnValue = true
        const totalValues = await calBalances(newListUpdate, returnValue)

        await Model.delete({
            url: `reports/projections/delete/flow/${id}`,
            dataForm: {
                id_item: form.id,
                id_ppto: pptoId,
                id_contacto: id_cliente,
                ...totalValues
            }
        })

    }

    const handleSave = async () => {

        await Model.update({
            url: 'reports/projections/items/flow',
            dataForm: {
                id_item: form.id,
                id_ppto: pptoId,
                id_contacto: id_cliente,
                total_item_ppto: form?.precio_subtotal,
                ...form,
                flows: flowsList
            }
        })

        setInitialFlowsList(flowsList)
        await handleGetInfoItem(form.id)
        handleGetFlows()

    }

    const handleSaveSelected = async (formUpdate, flowsListUpdated) => {

        await Model.update({
            url: 'reports/projections/items/flow',
            dataForm: {
                ...formUpdate,
                id_item: formUpdate.id,
                id_ppto: pptoId,
                id_contacto: id_cliente,
                total_item_ppto: formUpdate?.precio_subtotal,
                flows: flowsListUpdated
            }
        })

        await handleGetInfoItem(formUpdate.id)
        handleGetFlows()

    }

    const handleChangeSelectInvoice = async ({ target }, flow) => {
        const { value: invoiceId } = target

        if (invoiceId !== '') {
            const invoiceInfo = invoicesList.find(f => f.id === invoiceId)

            const totalItem = parseFloat(form.precio_subtotal)
            const montoBaseInvoice = parseFloat(invoiceInfo?.monto_base)
            const porcentajeFlow = (montoBaseInvoice / totalItem) * 100
            const montoNeto = montoBaseInvoice

            const newListUpdate = flowsList.map(flo => {
                if (flo.id === flow.id) {
                    return {
                        ...flo,
                        fecha_proyeccion: invoiceInfo.fecha_emision,
                        porcentaje_flow: porcentajeFlow,
                        monto_neto: montoNeto,
                        invoice_edit: true,
                        invoice_buy_id: invoiceId,
                        info_invoice: invoiceInfo
                    }
                }

                return flo
            })

            setFlowsList(newListUpdate)
            const totalesUpdated = await calBalances(newListUpdate, true)

            const newForm = {
                ...form,
                ...totalesUpdated
            }

            await handleSaveSelected(newForm, newListUpdate)
            iniCargarInvoices()

        }
    }

    const handleChangeSelectBuy = async ({ target }, flow) => {
        const { value: buyId } = target

        if (buyId !== '') {
            const buyInfo = buysList.find(b => b.id === buyId)
            // console.log({ buyInfo })

            const totalCostoItem = parseFloat(form.costo_subtotal)
            const montoBaseBuy = parseFloat(buyInfo?.monto_base)
            const porcentajeFlow = (montoBaseBuy / totalCostoItem) * 100
            const montoNeto = montoBaseBuy

            const newListUpdate = flowsList.map(flo => {
                if (flo.id === flow.id) {
                    return {
                        ...flo,
                        fecha_proyeccion: buyInfo.fecha_emision,
                        porcentaje_flow: porcentajeFlow,
                        monto_neto: montoNeto,
                        invoice_edit: true,
                        invoice_buy_id: buyId,
                        info_invoice: buyInfo,
                        id_proveedor: buyInfo.id_proveedor,
                        id_tipo_documento: buyInfo.id_tipo_documento,
                        porcentaje_impuesto: parseFloat(buyInfo.impuesto_porcentaje),
                        id_moneda: buyInfo.id_moneda,
                        valor_tipo_cambio: parseInt(buyInfo.id_moneda) === 4 ? buyInfo?.valor_tipo_cambio : 0,
                        separacion_decimales: buyInfo.separacion_decimales,
                        separacion_miles: buyInfo.separacion_miles,
                        simbolo: buyInfo.simbolo
                    }
                }

                return flo
            })

            setFlowsList(newListUpdate)
            const totalesUpdated = await calBalances(newListUpdate, true)

            const newForm = {
                ...form,
                ...totalesUpdated
            }

            await handleSaveSelected(newForm, newListUpdate)
            initLoadBuys()

        }
    }

    const handleRemoveInvoice = async (type, flow) => {
        const invoiceId = flow?.info_invoice.id

        const newListUpdate = flowsList.map(flo => {
            if (flo.id === flow.id) {
                return {
                    ...flo,
                    info_invoice: null
                }
            }

            return flo
        })

        setFlowsList(newListUpdate)
        const totalesUpdated = await calBalances(newListUpdate, true)

        await Model.update({
            url: `flows/remove/info-doc/${invoiceId}`,
            dataForm: {
                id: invoiceId,
                flow_id: flow.id,
                type,
                id_item: form.id,
                id_ppto: pptoId,
                ...totalesUpdated
            }
        })

        if (type === 'ingreso') {
            iniCargarInvoices()
        } else {
            initLoadBuys()
        }

        handleGetFlows()

    }

    const handleChangeDate = async (newValue, id) => {
        const newDate = newValue.target.value

        const newListUpdate = flowsList.map(flo => {
            if (flo.id === id) {
                return {
                    ...flo,
                    fecha_proyeccion: newDate
                }
            }

            return flo
        })

        setFlowsList(newListUpdate)

    }

    useEffect(() => {
        if (form.id) {
            handleGetFlows()
        }
    }, [form.id, handleGetFlows])

    useEffect(() => {
        if (!tasksList) {
            handleGetHitosTasks()
        }
    }, [tasksList, handleGetHitosTasks])

    useEffect(() => {
        iniCargarInvoices()
    }, [iniCargarInvoices])

    useEffect(() => {
        initLoadBuys()
    }, [initLoadBuys])

    return (
        <div>

            <Summary
                form={form}
                handleAdd={handleAdd}
            />

            <div className='d-flex justify-content-end mt-2'>

                {(JSON.stringify(initialFlowsList) !== JSON.stringify(flowsList)) ?
                    <button
                        style={{ width: '150px', margin: '10px' }}
                        className='btn p-btn-primary'
                        onClick={handleSave}
                    >Guardar cambios</button>
                    : ''
                }

            </div>

            {flowsList?.length === 0 ?
                <h5 style={{
                    fontSize: '15px',
                    marginLeft: '10px',
                    marginTop: '30px'
                }}>No hay flujos proyectados.</h5>
                :
                <table className="table tablesUI mt-1">
                    <thead>
                        <tr>
                            <th className='title text-center'>Tarea</th>
                            <th className='title text-center'>%</th>
                            <th className='title text-center'>Monto neto</th>
                            <th className='title text-end'>Fecha proyectada</th>
                            <th className='title text-end'></th>
                            <th className='title text-end'></th>
                        </tr>
                    </thead>
                    <tbody>
                        {flowsList?.map(flo => (
                            <tr key={flo.id}>
                                <td>
                                    <select
                                        style={{
                                            border: '1px solid lightgray',
                                            padding: '2px',
                                            backgroundColor: 'white',
                                            width: '180px',
                                            borderRadius: '3px',
                                            textAlign: 'left',
                                            textTransform: 'uppercase'
                                        }}
                                        name="id_tarea"
                                        onChange={(e) => handleChangeHito(e, flo.id)}
                                        disabled={flo?.info_invoice ? true : false}
                                    >
                                        <option key="" value="">--</option>
                                        {hitosList?.map(hi => (
                                            <>
                                                <option
                                                    key={hi.id}
                                                    selected={hi.id === flo?.id_tarea ? 'selected' : ''}
                                                    value={hi.id}
                                                >
                                                    HITO: {hi.nombre}
                                                </option>
                                                {hi.subs.map(ta => (
                                                    <>
                                                        <option
                                                            key={ta.id}
                                                            selected={ta.id === flo?.id_tarea ? 'selected' : ''}
                                                            value={ta.id}
                                                            className='p-2'
                                                        >--TA: {ta.nombre}
                                                        </option>
                                                        {ta.subs.map(st => (
                                                            <option
                                                                key={st.id}
                                                                selected={st.id === flo?.id_tarea ? 'selected' : ''}
                                                                value={st.id}
                                                                className='p-2'
                                                            >----ST: {st.nombre}
                                                            </option>
                                                        ))}
                                                    </>
                                                ))}
                                                <hr />
                                            </>
                                        ))}
                                    </select>
                                </td>
                                <td>
                                    <NumberFormat
                                        style={{ width: '70px', border: flo?.info_invoice ? 'none' : '' }}
                                        className="text-end p-cantidades-item-new2"
                                        name="porcentaje_flow"
                                        value={flo?.porcentaje_flow || 0}
                                        thousandSeparator=','
                                        decimalSeparator='.'
                                        suffix="%"
                                        decimalScale={2}
                                        fixedDecimalScale={2}
                                        onValueChange={(values, sourceInfo) => handleChangeNumberPercent({ ...values, sourceInfo }, flo.id)}
                                        disabled={flo?.info_invoice ? true : false}
                                    />
                                </td>
                                <td>
                                    <div className='d-flex justify-content-start align-items-end'>

                                        <div className='d-flex flex-column justify-content-start align-items-end'>
                                            <NumberFormat
                                                className="text-end p-cantidades-item-new2"
                                                style={{ width: '150px', border: flo?.info_invoice ? 'none' : '' }}
                                                name="monto_neto"
                                                value={parseFloat(flo?.monto_neto || 0)}
                                                thousandSeparator={flo?.separacion_miles || separacion_miles}
                                                decimalSeparator={flo?.separacion_decimales || separacion_decimales}
                                                prefix={`${flo?.simbolo || simbolo} `}
                                                decimalScale={2}
                                                fixedDecimalScale={2}
                                                onValueChange={(values, sourceInfo) => handleChangeNumber({ ...values, sourceInfo }, flo.id)}
                                                disabled={flo?.info_invoice ? true : false}
                                            />
                                            {parseInt(flo?.id_moneda) === 3 && parseInt(id_moneda) === 4 ?
                                                <NumberFormat
                                                    className="text-end p-cantidades-item-new2"
                                                    style={{
                                                        width: '150px',
                                                        border: flo?.info_invoice ? 'none' : '',
                                                        fontSize: '10px',
                                                        marginTop: '5px'
                                                    }}
                                                    displayType={'text'}
                                                    name="monto_neto"
                                                    value={parseFloat((flo?.monto_neto || 0) / valor_tipo_cambio)}
                                                    thousandSeparator={separacion_miles}
                                                    decimalSeparator={separacion_decimales}
                                                    prefix={`${simbolo} `}
                                                    decimalScale={2}
                                                    fixedDecimalScale={2}
                                                    onValueChange={(values, sourceInfo) => handleChangeNumber({ ...values, sourceInfo }, flo.id)}
                                                    disabled={flo?.info_invoice ? true : false}
                                                /> : ''
                                            }
                                        </div>

                                        {flo.tipo_flujo === 'ingreso' ?
                                            <i
                                                className="bi bi-arrow-up ms-1"
                                                style={{ color: 'green', fontSize: '15px' }}>
                                            </i> :
                                            <i
                                                className="bi bi-arrow-down ms-1"
                                                style={{ color: 'red', fontSize: '15px' }}>
                                            </i>
                                        }
                                    </div>
                                </td>
                                <td className='text-center'>
                                    <input
                                        style={{ padding: '2px', borderRadius: '3px', border: '1px solid lightgray' }}
                                        type="date"
                                        value={flo?.fecha_proyeccion}
                                        onChange={(value) => handleChangeDate(value, flo.id)}
                                        disabled={flo?.info_invoice ? true : false}
                                    />
                                </td>
                                <td className='text-start'>
                                    {flo.tipo_flujo === 'ingreso' ?
                                        <SelectInvoice
                                            flo={flo}
                                            handleRemoveInvoice={handleRemoveInvoice}
                                            handleOpenNewInvoice={handleOpenNewInvoice}
                                            handleChangeSelectInvoice={handleChangeSelectInvoice}
                                            invoicesList={invoicesList}
                                        />
                                        :
                                        <SelectBuy
                                            flo={flo}
                                            handleRemoveInvoice={handleRemoveInvoice}
                                            handleOpenNewInvoice={handleOpenNewInvoice}
                                            handleChangeSelectBuy={handleChangeSelectBuy}
                                            invoicesList={buysList}
                                        />
                                    }
                                </td>
                                <td>
                                    {!flo?.info_invoice ?
                                        < i
                                            className="bi bi-trash"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => handleRemove(flo.id)}
                                        ></i> : ''
                                    }
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table >

            }


        </div >
    )
}

const SelectInvoice = ({ flo, handleRemoveInvoice, handleChangeSelectInvoice, handleOpenNewInvoice, invoicesList }) => {
    return (

        <>
            {flo?.info_invoice ?
                <div className="d-flex justify-content-between align-items-end">
                    <Link
                        className="p-mini-link"
                        to={`/facturas/${flo?.info_invoice?.id}`}
                        target='_blank'
                        style={{ fontSize: '12px', textTransform: 'capitalize', color: 'green' }}
                    >
                        <div className="text-start">
                            <i class="bi bi-check-circle-fill"></i>
                            <span className='ms-1'>Facturado</span>
                        </div>
                        <div className="text-start ms-3"
                            style={{ textTransform: 'uppercase', fontSize: '10px', color: 'gray' }}>
                            Nro. {flo?.info_invoice?.numero}
                        </div>
                    </Link>
                    <Link
                        to=""
                        style={{
                            fontSize: '11px',
                            textTransform: 'none',
                            textDecoration: 'none',
                            color: "gray"
                        }}
                        onClick={() => handleRemoveInvoice("ingreso", flo)}
                    >
                        <i className="bi bi-x"></i>
                        Quitar factura
                    </Link>
                </div>
                :
                <div className='d-flex flex-column justify-content-start align-items-start'>
                    <Link
                        to=""
                        onClick={() => handleOpenNewInvoice(flo, 'ingreso')}
                        className="p-mini-link"
                        style={{ fontSize: '12px', textTransform: 'capitalize', color: 'green' }}
                    >
                        + Crear factura
                    </Link>

                    {invoicesList.length > 0 ?
                        <select
                            className='mt-1'
                            style={{ cursor: 'pointer', width: '180px', textTransform: 'uppercase', fontSize: '11px' }}
                            onChange={(e) => handleChangeSelectInvoice(e, flo)}
                        >
                            <option value=''>--seleccionar existente--</option>
                            {invoicesList.map(inv => (
                                <option
                                    key={inv.id}
                                    value={inv.id}
                                    className='p-2'
                                >Nro. {inv.numero}{' | '}{inv.referencia}
                                </option>
                            ))}
                        </select> : ''
                    }

                </div>
            }
        </>

    )
}

const SelectBuy = ({ flo, handleRemoveInvoice, handleChangeSelectBuy, handleOpenNewInvoice, invoicesList }) => {
    return (
        <>
            {flo?.info_invoice ?
                <div className="d-flex justify-content-between align-items-center">
                    <Link
                        className="p-mini-link"
                        to={`/gastos/compras/${flo?.info_invoice?.id}`}
                        target='_blank'
                        style={{ fontSize: '12px', textTransform: 'capitalize', color: 'red' }}
                    >
                        <div className="text-start">
                            <i class="bi bi-check-circle-fill"></i>
                            <span className='ms-1'>Gastado</span>
                        </div>
                        <div
                            className="text-start ms-3"
                            style={{ textTransform: 'uppercase', fontSize: '10px', color: 'gray' }}
                        >
                            <span>Nro. {flo?.info_invoice?.numero}</span><br />
                            <span>{flo?.info_invoice?.nro_doc_justificacion}</span>
                        </div>
                    </Link>
                    <Link
                        to=""
                        style={{
                            fontSize: '11px',
                            textTransform: 'none',
                            textDecoration: 'none',
                            color: "gray"
                        }}
                        onClick={() => handleRemoveInvoice("egreso", flo)}
                    >
                        <i className="bi bi-x"></i>
                        Quitar gasto
                    </Link>
                </div>
                :
                <div className='d-flex flex-column justify-content-start align-items-start'>
                    <Link
                        to=""
                        onClick={() => handleOpenNewInvoice(flo, 'egreso')}
                        className="p-mini-link"
                        style={{ fontSize: '12px', textTransform: 'capitalize', color: 'red' }}
                    >
                        + Crear gasto
                    </Link>

                    {invoicesList.length > 0 ?
                        <select
                            className='mt-1'
                            style={{ cursor: 'pointer', width: '180px', textTransform: 'uppercase', fontSize: '11px' }}
                            onChange={(e) => handleChangeSelectBuy(e, flo)}
                        >
                            <option value=''>--seleccionar existente--</option>
                            {invoicesList.map(inv => (
                                <option
                                    key={inv.id}
                                    value={inv.id}
                                    className='p-2'
                                >
                                    {inv?.nro_doc_justificacion ?
                                        <span>Nro. {inv.numero}{' | '}{inv?.nro_doc_justificacion}{' | '}{inv.referencia}</span>
                                        :
                                        <span>Nro. {inv.numero}{' | '}{inv.referencia}</span>
                                    }
                                </option>
                            ))}
                        </select> : ''
                    }

                </div>
            }
        </>

    )
}